module.exports = __webpack_public_path__ + "static/media/logPicOne.27433028.jpeg";